import { styled } from '@abyss/web/tools/styled';
import { Badge } from '@abyss/web/ui/Badge';
import { Button } from '@abyss/web/ui/Button';
import { Checkbox } from '@abyss/web/ui/Checkbox';
import { Flex } from '@abyss/web/ui/Flex';
import { Layout } from '@abyss/web/ui/Layout';
import { Text } from '@abyss/web/ui/Text';

export const LocationCardContainer = styled('div', {
  margin: '14px',
  display: 'flex'
});

export const LocationCardWrapper = styled('div', {
  background: '$primary2',
  width: '408px',
  textAlign: 'left',
  '@screen < $sm': {
    width: '100%',
    height: 'auto',
  },
  '&.location-card-map-view': {
    width: '320px',
    height: '162px',
    '@screen < $sm': {
      height: 'auto',
    },
    '.location-details': {
      '>div': {
        width: 'auto',
        height: 'inherit',
      },
    },
  },
});

export const PreferredBadgeWrapper = styled('div', {
  paddingBottom: '8px',
  '@screen < $sm': {
    paddingBottom: '4px',
  },
});

export const LocationCardGroup = styled(Layout.Group, {
  '&.abyss-layout-group': {
    alignItems: 'flex-start',
    '@screen < $sm': {
      // height: '125px',
    },
  },
});

export const LocationDetailsStack = styled(Flex, {
  flex: 1,
  minWidth: 0,
  gap: '8px',
  lineHeight: '23px',
  '@screen < $sm': {
    lineHeight: '18px',
  },
  '>span': {
    overflowWrap: 'anywhere',
    width: '100%',
  },
});

export const LocationDetailsAddress = styled(Text, {
  lineHeight: '24px',
  fontSize: '18px',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  maxWidth: '342px',
  '@screen < $sm': {
    lineHeight: '20px',
    fontSize: '14.22px',
    maxWidth: '258px',
  },
});

export const LocationBadgeRow = styled(Flex, {
  height: '20px',
  gap: '16px',
  flexDirection: 'column',
});

export const MilesButton = styled('div', {
  display: 'flex',
  gap: '8px',
  alignItems: 'center',
});

export const AcceptingNewPatientsBadge = styled(Badge, {
  fontSize: '12px',
});

export const StyledCheckIcon = styled('div', {
  height: '24px',
});

export const UpdateButtonMobileViewContainer = styled('div', {
  display: 'flex',
  justifyContent: 'center',
});

export const UpdateButtonMobileView = styled(Button, {
  '&.abyss-button-root': {
    display: 'flex',
    padding: '8px 20px',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '4px',
    height: '42px',
    fontWeight: '$semibold',
    fontSize: '16px',
    lineHeight: '20px',
    '.abyss-insert-element-after': {
      paddingLeft: 0,
    },
  },
});

export const SelectLocationCheckbox = styled(Checkbox, {
  '&.abyss-checkbox': {
    '&&:disabled': {
      backgroundColor: '$gray4',
      borderColor: '$gray6',
    },
    '&&:checked:disabled': {
      backgroundColor: '$gray6',
      borderColor: '$gray6',
    },
  },
})

export const ModalPhoneText = styled(Text, {
  lineHeight: '18px',
  fontWeight: '500',
  padding: '0 4px !important',
  cursor: 'pointer',
  '@screen < $sm': {
    fontSize: '16px !important',
  }
})

export const PhoneTag = styled('a', {
  display: 'flex',
  alignItems: 'center',
  textDecoration: 'none',
  '&:hover,&:active': {
    textDecoration: 'none',
  },
  marginTop: '0.5rem',
});